// The platform-wide mastery line, on a 0–100 scale. An outcome scored below it is "unmastered" / a gap.
// The BACKEND is the single source (`MasteryConstants.MASTERY_THRESHOLD`); it arrives on the learner
// performance (`unifiedLearnerPerformance.masteryThreshold`) inside the bootstrap LearnerApp already
// loads — no extra request. Readiness, the learning
// path's mastered/weak split and the strengths & weaknesses quadrant all read it through
// getMasteryThreshold(). MASTERY_THRESHOLD is only the fallback for before the load, or if it fails.
export const MASTERY_THRESHOLD = 70;

let masteryThreshold = MASTERY_THRESHOLD;

export const getMasteryThreshold = (): number => masteryThreshold;

/** Accepts only a finite 0–100 value; anything else keeps the current line. */
export const setMasteryThreshold = (value: unknown): void => {
  if (typeof value === "number" && Number.isFinite(value) && value >= 0 && value <= 100) {
    masteryThreshold = value;
  }
};

// Max prerequisite levels the learning-path readiness view drills into (breadcrumb chain length).
// Mirrors the backend ReadinessConstants.MAX_READINESS_DEPTH; beyond this depth prerequisite cards
// render without bars/locks so a deep graph never gates the learner indefinitely.
export const READINESS_MAX_DEPTH = 4;
